import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  recaptchaToken: '',
  securityToken: '',
};

const slice = createSlice({
  name: 'security',
  initialState: reHydrateStore('security') || initialState,
  reducers: {
    setRecaptchaToken: (state, { payload }) => ({
      ...state,
      recaptchaToken: payload,
    }),
    setSecurityToken: (state, { payload }) => ({
      ...state,
      securityToken: payload,
    }),
    restore: (state, { payload }) => ({
      ...initialState,
    }),
  },
});

export const { setRecaptchaToken, setSecurityToken, restore } = slice.actions;

export default slice.reducer;
